import React from "react";

export default function ValidatorEnterPriceCard({
    icon,
    title,
    tagText,
    isDisabled
}) {

    return (
        <div className={`relative w-full flex flex-col justify-between gap-6 laptop:gap-[30px] rounded-[18px] border-[1.5px] border-[#FDFDFD]/[0.04] p-5 laptop:p-6 laptop:pb-5 bg-noise bg-cover bg-no-repeat bg-center bg-[#1A1A1A] overflow-hidden h-full group duration-500 ${isDisabled ? "opacity-50 cursor-not-allowed blur-effect backdrop-blur-effect" : ""}`}>
            <div className="flex items-center gap-4 laptop:gap-5">
                <div className="flex items-center justify-center p-[8px] w-[90px] h-[90px] rounded-2xl bg-[#010101]">
                    {!isDisabled && <img
                        src={icon}
                        alt=""
                        className=""
                    />}
                </div>
                <div className="flex flex-col gap-3 laptop:gap-[12px]">
                    <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-primaryWhite">
                        {isDisabled ? "Coming Soon" :title}
                    </h4>
                    <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-xl h-9 max-w-fit">
                        {tagText!=="inactive" && <span className="w-[6px] h-[6px] rounded-full bg-green"></span>}
                        {tagText}
                    </div>
                </div>
            </div>
        </div>
    );
}
